module.exports = __webpack_public_path__ + "img/制御工学6_7.ac20adda.png";